
import { defineComponent, PropType } from 'vue'
import Label from '@/components/AtomLabel.vue'
import Field from '@/components/AtomField.vue'
import Select from '@/components/AtomSelect.vue'

interface SelectOption {
  text: string,
  value: string,
}

export default defineComponent({
  emits: ['onChange'],
  components: {
    Label,
    Field,
    Select
  },
  props: {
    name: String as PropType<string>,
    value: String as PropType<string>,
    id: String as PropType<string>,
    label: String as PropType<string>,
    options: Object as PropType<SelectOption[]>
  },
  methods: {
    onChange (value: string) {
      this.$emit('onChange', value)
    }
  }
})
